export const ContactSalesPagePTBRTranslations = {
  contactSalesPageHeadDescription:
    'Tire suas dúvidas conosco. Fale com nossos especialistas.',
  contactSalesPageTitle:
    'Entre em contato conosco e saiba mais sobre como podemos ajudar seu negócio',
  contactSalesPageDescription:
    'Preencha o formulário ou use o botão abaixo para nos contatar pelo WhatsApp',
  contactSalesPageWhatsAppButton: 'Falar pelo WhatsApp',
};
